import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "faq"
    }}>{`FAQ:`}</h1>
    <h2 {...{
      "id": "how-to-configure-stripe-payment-gateway"
    }}>{`How to configure Stripe payment gateway?`}</h2>
    <p>{`To configure `}<inlineCode parentName="p">{`Stripe`}</inlineCode>{` payment gateway,`}</p>
    <ol>
      <li parentName="ol">{`At first, create a developer account from stripe developer dashboard (`}<a parentName="li" {...{
          "href": "https://dashboard.stripe.com/"
        }}>{`https://dashboard.stripe.com/`}</a>{`)`}</li>
      <li parentName="ol">{`log in to that account`}</li>
      <li parentName="ol">{`Then go to the `}<inlineCode parentName="li">{`Developer -> API Keys`}</inlineCode>{` section and on that section create an API key. After creating, you'll get one `}<inlineCode parentName="li">{`Secret key`}</inlineCode>{` and one `}<inlineCode parentName="li">{`Publishable key.`}</inlineCode>
        <img alt="StripeDev.png" src={require("./images/StripeDev.png")} /></li>
      <li parentName="ol">{`Then copy `}<inlineCode parentName="li">{`Secret key`}</inlineCode>{` to your `}<inlineCode parentName="li">{`pickbazar`}</inlineCode>{` `}<inlineCode parentName="li">{`api->.env`}</inlineCode></li>
    </ol>
    <p><img alt="SetStripeAPI.png" src={require("./images/SetStripeAPI.png")} /></p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`And similarly, add `}<inlineCode parentName="li">{`Publishable key`}</inlineCode>{` to your `}<inlineCode parentName="li">{`frontend/shop-rest/.env`}</inlineCode>{` for rest and `}<inlineCode parentName="li">{`frontend/shop-graphql/.env`}</inlineCode>{` for graphql.
`}<img alt="FrontStripe.png" src={require("./images/FrontStripe.png")} /></li>
    </ol>
    <p>{`After configuration, make sure you rebuild your project using this command,`}</p>
    <p>{`For REST API`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn build:shop-rest
yarn build:admin-rest
`}</code></pre>
    <p>{`And for GraphQL,`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn build:shop-gql
yarn build:admin-gql
`}</code></pre>
    <h2 {...{
      "id": "why-am-i-facing-you-may-need-an-appropriate-loader-to-handle-this-file-type-during-running-shop-rest"
    }}>{`Why am I facing "You may need an appropriate loader to handle this file type" during running shop rest?`}</h2>
    <p>{`Ans: Please run `}<inlineCode parentName="p">{`yarn clean`}</inlineCode>{` then `}<inlineCode parentName="p">{`yarn`}</inlineCode>{` then run `}<inlineCode parentName="p">{`yarn dev:shop-rest`}</inlineCode></p>
    <h2 {...{
      "id": "i-am-changing-schema-files-but-changes-is-not-working"
    }}>{`I am changing schema files but changes is not working`}</h2>
    <p>{`Your changes might not work because schema is cached. SO you might need to clear schema cache using the below command `}<inlineCode parentName="p">{`php artisan lighthouse:clear-cache`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "changing-env-files-but-not-getting-the-changes"
    }}>{`Changing .env files but not getting the changes`}</h2>
    <p>{`Run Below command `}<inlineCode parentName="p">{`php artisan optimize:clear`}</inlineCode></p>
    <h2 {...{
      "id": "changing-route-but-not-getting-the-changes"
    }}>{`Changing route but not getting the changes.`}</h2>
    <p>{`Run `}<inlineCode parentName="p">{`php artisan optimize:clear`}</inlineCode>{` or `}<inlineCode parentName="p">{`php artisan route:clear`}</inlineCode></p>
    <h2 {...{
      "id": "i-have-set-stripe_api_key-in-env-but-still-getting-error"
    }}>{`I have set `}<inlineCode parentName="h2">{`STRIPE_API_KEY`}</inlineCode>{` in .env but still getting error.`}</h2>
    <p>{`In some cases `}<inlineCode parentName="p">{`STRIPE_API_KEY`}</inlineCode>{` value can't read from .env in those cases you have to put the key in the config file directly in `}<inlineCode parentName="p">{`api/packages/marvel/src/Config/laravel-omnipay.php`}</inlineCode></p>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">
        <p parentName="li">{`Getting error on forget password email sending
Make sure you have run the `}<inlineCode parentName="p">{`php artisan marvel:install`}</inlineCode>{` commands successfully and copied the necessary email templates to your resources folder. You can also do it by `}<inlineCode parentName="p">{`php artisan marvel:copy-files`}</inlineCode>{` command.`}</p>
        <blockquote parentName="li">
          <p parentName="blockquote">{`NB: This same issue can occur during order creation.`}</p>
        </blockquote>
      </li>
    </ol>
    <h2 {...{
      "id": "can-i-use-it-with-my-existing-laravel"
    }}>{`Can I use it with my existing laravel?`}</h2>
    <p>{`Yes, you can. Follow the below steps.`}</p>
    <ul>
      <li parentName="ul">{`Make sure you are using laravel 8.`}</li>
      <li parentName="ul">{`Copy `}<inlineCode parentName="li">{`api/packages`}</inlineCode>{` folder from the downloaded files into your laravel root folder.`}</li>
      <li parentName="ul">{`Put below code in your laravel `}<inlineCode parentName="li">{`composer.json`}</inlineCode>{` file into `}<inlineCode parentName="li">{`require`}</inlineCode>{` section.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"ignited/laravel-omnipay": "dev-master",
"omnipay/common": "dev-master",
"omnipay/stripe": "dev-master",
"pickbazar/shop": "dev-master"
`}</code></pre>
    <ul>
      <li parentName="ul">{`Put below code in bottom of your `}<inlineCode parentName="li">{`composer.json`}</inlineCode>{`. If you already have an `}<inlineCode parentName="li">{`repositories`}</inlineCode>{` section then put code
inside `}<inlineCode parentName="li">{`repositories`}</inlineCode>{` to your existing `}<inlineCode parentName="li">{`repositories`}</inlineCode></li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`"repositories": {
        "pickbazar/shop": {
            "type": "path",
            "url": "packages/marvel"
        },
        "ignited/laravel-omnipay": {
            "type": "path",
            "url": "packages/laravel-omnipay"
        },
        "omnipay/common": {
            "type": "path",
            "url": "packages/omnipay-common"
        },
        "omnipay/stripe": {
            "type": "path",
            "url": "packages/omnipay-stripe"
        }
    }
`}</code></pre>
    <ul>
      <li parentName="ul">{`Now run `}<inlineCode parentName="li">{`composer install`}</inlineCode></li>
      <li parentName="ul">{`Copy necessary env variables from .env.example to you env file.`}</li>
      <li parentName="ul">{`Run `}<inlineCode parentName="li">{`php artisan marvel:install`}</inlineCode>{` and follow necessary steps.`}</li>
      <li parentName="ul">{`To run server `}<inlineCode parentName="li">{`php artisan serve`}</inlineCode></li>
      <li parentName="ul">{`For image upload to work properly you need to run `}<inlineCode parentName="li">{`php artisan storage:link`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "why-am-i-getting-access-denied-for-user"
    }}>{`Why am I getting `}<inlineCode parentName="h2">{`Access denied for user`}</inlineCode>{`?`}</h2>
    <p>{`navigate to `}<inlineCode parentName="p">{`api`}</inlineCode>{` then run `}<inlineCode parentName="p">{`./vendor/bin/php down -v`}</inlineCode>{`. It will delete any of your existing mysql volumes. Now run `}<inlineCode parentName="p">{`./vendor/bin/php up -d`}</inlineCode>{` on same directory or run `}<inlineCode parentName="p">{`bash install.sh`}</inlineCode>{` on root directory`}</p>
    <h2 {...{
      "id": "why-am-i-getting-permission-issue-during-deployment"
    }}>{`Why am I getting permission issue during deployment?`}</h2>
    <p>{`Run below commands for fixing permission issue in your laravel app during deployment`}</p>
    <pre><code parentName="pre" {...{}}>{`
sudo chown -R $USER:www-data storage
sudo chown -R $USER:www-data bootstrap/cache

sudo chown -R www-data:www-data storage
sudo chown -R www-data:www-data bootstrap/cache

`}</code></pre>
    <h2 {...{
      "id": "why-am-i-getting-the-get-method-is-not-supported-for-this-route-supported-methods-head"
    }}>{`Why am I getting "The GET method is not supported for this route. Supported methods: HEAD"?`}</h2>
    <p>{`Run `}<inlineCode parentName="p">{`php artisan optimize:clear`}</inlineCode></p>
    <h2 {...{
      "id": "how-to-resolve-the-load-more-infinity-loading-issue"
    }}>{`How to resolve the `}<inlineCode parentName="h2">{`Load More`}</inlineCode>{` `}<inlineCode parentName="h2">{`Infinity`}</inlineCode>{` loading issue?`}</h2>
    <p>{`If you click on the `}<inlineCode parentName="p">{`Load More`}</inlineCode>{` button and the button is spinning continuously, then check API request from the network tab. If it is HTTP and your API is hosted on HTTPS, then open,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`/Users/tareqmahmud/tmbox/tmserver/larabox/work/redq/laravel-ecommerce/api/app/Providers/AppServiceProvider.php
`}</code></pre>
    <p>{`And add this code to `}<inlineCode parentName="p">{`boot`}</inlineCode>{` method,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`if (!\\App::environment('local')) {
    $this->app['request']->server->set('HTTPS', true);
}
`}</code></pre>
    <h2 {...{
      "id": "im-trying-to-upload-images-but-the-images-are-not-displayed-on-the-frontend"
    }}>{`I'm trying to upload images, but the images are not displayed on the frontend?`}</h2>
    <p>{`We support two types of file uploads; one is `}<inlineCode parentName="p">{`local,`}</inlineCode>{` and another is `}<inlineCode parentName="p">{`AWS S3`}</inlineCode>{`.`}</p>
    <p>{`Both uploading systems follow this procedure,`}</p>
    <h4 {...{
      "id": "api"
    }}>{`API`}</h4>
    <p>{`At first, add your API URL to your `}<inlineCode parentName="p">{`api -> .env.`}</inlineCode></p>
    <p><img alt="APIDomain.png" src={require("./images/APIDomain.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`If you're using windows and your API is running with ports like `}<inlineCode parentName="p">{`localhost:8000`}</inlineCode>{` or `}<inlineCode parentName="p">{`127.0.0.1:8000`}</inlineCode>{`, then make sure you add the domain with port to `}<inlineCode parentName="p">{`APP_URL.`}</inlineCode>{` Like this `}<inlineCode parentName="p">{`API_URL=http://localhost:8000`}</inlineCode></p>
    </blockquote>
    <p>{`After that, clear your API cache by using this command from the `}<inlineCode parentName="p">{`api`}</inlineCode>{` folder,`}</p>
    <pre><code parentName="pre" {...{}}>{`php artisan optimize:clear
`}</code></pre>
    <p>{`Then link the storage system by using this command,`}</p>
    <pre><code parentName="pre" {...{}}>{`php artisan storage:link
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`If you're using AWS S3, then update `}<inlineCode parentName="p">{`MEDIA_DISK=s3`}</inlineCode>{` and add all `}<inlineCode parentName="p">{`AWS_`}</inlineCode>{` credentials
For AWS s3, make sure your properly setup permission of the bucket with ACL enable by follow this link -> `}<a parentName="p" {...{
          "href": "https://stackoverflow.com/a/70603995/2158023"
        }}>{`https://stackoverflow.com/a/70603995/2158023`}</a></p>
    </blockquote>
    <p><img alt="aws_s3_permissions" src={require("./images/aws_s3_permissions.png")} /></p>
    <h4 {...{
      "id": "admin"
    }}>{`Admin`}</h4>
    <p>{`Then add your domain to your `}<inlineCode parentName="p">{`pickbazar-laravel -> admin -> rest -> next.config.js`}</inlineCode>{` for `}<inlineCode parentName="p">{`rest`}</inlineCode>{` or `}<inlineCode parentName="p">{`pickbazar-laravel -> admin -> graphql -> next.config.js`}</inlineCode>{` for `}<inlineCode parentName="p">{`graphql`}</inlineCode></p>
    <p><img alt="AddYourDomain.png" src={require("./images/AddYourDomain.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`If you're using `}<inlineCode parentName="p">{`AWS S3`}</inlineCode>{`, then also add your root S3 domain like this,
`}<img alt="S3Domain.png" src={require("./images/S3Domain.png")} /></p>
    </blockquote>
    <h4 {...{
      "id": "shop"
    }}>{`Shop`}</h4>
    <p>{`Similarly, add your domain to your `}<inlineCode parentName="p">{`pickbazar-laravel -> shop -> next.config.js`}</inlineCode></p>
    <p><img alt="AddYourDomain.png" src={require("./images/AddYourDomain.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`If you're using `}<inlineCode parentName="p">{`AWS S3`}</inlineCode>{`, then also add your root S3 domain like this,
`}<img alt="S3Domain.png" src={require("./images/S3Domain.png")} /></p>
    </blockquote>
    <h4 {...{
      "id": "build-frontend"
    }}>{`Build Frontend,`}</h4>
    <p>{`If you run in dev mode, then re-run will affect your update. But if you're running as a production mode, then you've to rebuild the project and re-run again. Otherwise, image upload will not work.`}</p>
    <p><a parentName="p" {...{
        "href": "/faq#how-to-rebuild-the-project"
      }}>{`https://pickbazar-doc.vercel.app/vps-server#build-project`}</a></p>
    <p>{`After building the project, replace your server shop and admin folder using this rebuild folder and re-run the app using this command,`}</p>
    <pre><code parentName="pre" {...{}}>{`pm2 restart all
`}</code></pre>
    <h2 {...{
      "id": "how-to-resolve-the-502-bad-gateway-error-for-frontendadmin"
    }}>{`How to resolve the `}<inlineCode parentName="h2">{`502 Bad Gateway`}</inlineCode>{` error for frontend/admin?`}</h2>
    <p>{`There can be several reasons that throw 502 errors for the frontend in the production server.`}</p>
    <h3 {...{
      "id": "reason-1"
    }}>{`Reason 1:`}</h3>
    <p>{`On your `}<inlineCode parentName="p">{`Nginx file, a specific port is set for shop or the admin, so when you run the script as a `}</inlineCode>{`PM2\` instance, the script has to be run that specific port; otherwise, your domain/subdomain will throw a 502 error.`}</p>
    <h4 {...{
      "id": "port"
    }}>{`PORT:`}</h4>
    <pre><code parentName="pre" {...{}}>{`3000 -> Shop Rest
3001 -> Admin Rest

3000 -> Shop GraphQL
3004 -> Admin GraphQL
`}</code></pre>
    <p>{`To check that at the first stop the PM2 instance by this command,`}</p>
    <pre><code parentName="pre" {...{}}>{`pm2 stop 'all'
`}</code></pre>
    <p>{`then go to the `}<inlineCode parentName="p">{`pickbazar`}</inlineCode>{` folder from your server and try to run the script using yarn and check which port it is running,`}</p>
    <p><inlineCode parentName="p">{`Rest:`}</inlineCode></p>
    <pre><code parentName="pre" {...{}}>{`yarn start:admin-rest
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`yarn shop-rest
`}</code></pre>
    <p><inlineCode parentName="p">{`GraphQL:`}</inlineCode></p>
    <pre><code parentName="pre" {...{}}>{`yarn start:admin-gql
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`yarn shop-gql
`}</code></pre>
    <p>{`And, check if the port matched with the Nginx port or not? If not matched, then change the port to `}<inlineCode parentName="p">{`Nginx`}</inlineCode>{` config.`}</p>
    <h3 {...{
      "id": "reason-2"
    }}>{`Reason 2:`}</h3>
    <p>{`To check that at the first stop the PM2 instance by this command,`}</p>
    <pre><code parentName="pre" {...{}}>{`pm2 stop 'all'
`}</code></pre>
    <p>{`then go to the `}<inlineCode parentName="p">{`pickbazar`}</inlineCode>{` folder from your server and try to run the script using yarn and check which port it is running,`}</p>
    <p><inlineCode parentName="p">{`Rest:`}</inlineCode></p>
    <pre><code parentName="pre" {...{}}>{`yarn start:admin-rest
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`yarn shop-rest
`}</code></pre>
    <p><inlineCode parentName="p">{`GraphQL:`}</inlineCode></p>
    <pre><code parentName="pre" {...{}}>{`yarn start:admin-gql
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`yarn shop-gql
`}</code></pre>
    <p>{`With this command, it'll give you an error that no build file is found. To resolve that, rebuild your project and then rerun the scripts.`}</p>
    <p><a parentName="p" {...{
        "href": "https://pickbazar-doc.vercel.app/re-build-shop"
      }}>{`https://pickbazar-doc.vercel.app/re-build-shop`}</a></p>
    <h2 {...{
      "id": "how-to-resolve-javascript-heap-out-of-memory-issue"
    }}>{`How to resolve `}<inlineCode parentName="h2">{`javascript heap out of memory`}</inlineCode>{` issue?`}</h2>
    <p>{`If you're using cPanel based server, then you maybe get an error like "call_and_retry_last allocation failed - javascript heap out of memory".`}</p>
    <p>{`To resolve that issue, you've to add a limit of the memory bound,`}</p>
    <p>{`Please check this,`}</p>
    <p><a parentName="p" {...{
        "href": "https://stackoverflow.com/questions/38558989/node-js-heap-out-of-memory"
      }}>{`https://stackoverflow.com/questions/38558989/node-js-heap-out-of-memory`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://support.snyk.io/hc/en-us/articles/360002046418-JavaScript-heap-out-of-memory"
      }}>{`https://support.snyk.io/hc/en-us/articles/360002046418-JavaScript-heap-out-of-memory`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://blog.openreplay.com/javascript-heap-out-of-memory-error"
      }}>{`https://blog.openreplay.com/javascript-heap-out-of-memory-error`}</a></p>
    <h2 {...{
      "id": "image-upload-throw-internal-server-error-how-to-resolve-that"
    }}>{`Image upload throw Internal Server Error; how to resolve that?`}</h2>
    <p>{`For uploading, the php8.1-gd library is required. So make sure you install the php8.1-gd library on your server.`}</p>
    <h2 {...{
      "id": "how-to-resolve-docker-invalid-reference-format-repository-name-must-be-lowercase"
    }}>{`How to resolve docker `}<inlineCode parentName="h2">{`invalid reference format: repository name must be lowercase`}</inlineCode>{`?`}</h2>
    <p>{`To resolve that issue, you've to move the `}<inlineCode parentName="p">{`laravel-ecommerce`}</inlineCode>{` folder from `}<inlineCode parentName="p">{`Pickbazar Laravel - React Next REST & GraphQL Ecommerce`}</inlineCode>{` to a genric folder where you store your code. After that, use this command from your `}<inlineCode parentName="p">{`laravel-ecommerce`}</inlineCode>{` folder,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`chmod +x install.sh
bash install.sh
`}</code></pre>
    <h2 {...{
      "id": "sometimes-my-server-shutdown-or-halts-automatically-after-restart-it-works-fine-again-how-to-resolve-that"
    }}>{`Sometimes my server shutdown or halts automatically. After restart, it works fine again; how to resolve that?`}</h2>
    <p>{`In general, this happens mainly when your upstream server fails to handle its processing power when there is lots of traffic or requires lots of operation. Please upgrade your server configuration to double to check the issue. Please check this video,`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=4pIqAz5bzX0"
      }}>{`https://www.youtube.com/watch?v=4pIqAz5bzX0`}</a></p>
    <p>{`If that doesn't solve the issue, then you've to redeploy again with a new ec2 instance.`}</p>
    <h2 {...{
      "id": "s3-uploading-doesnt-work-after-adding-credentials-to-env-how-to-resolve-that"
    }}>{`S3 uploading doesn't work after adding credentials to .env; how to resolve that?`}</h2>
    <p>{`For AWS s3, make sure your properly setup permission of the bucket with ACL enable by follow this link`}</p>
    <p><a parentName="p" {...{
        "href": "https://stackoverflow.com/a/70603995/2158023"
      }}>{`https://stackoverflow.com/a/70603995/2158023`}</a></p>
    <h2 {...{
      "id": "how-to-rebuild-the-project"
    }}>{`How to rebuild the project?`}</h2>
    <p>{`When you upload the code to the server as a production, NextJS fetch its code from the build file. So after deployed, when you update or change code on scripts, the updated scripts don't work at the front end until you rebuild the project again. NextJs works this way.`}</p>
    <p>{`Now there are two ways you can follow to rebuild the project,`}</p>
    <p>{`If your server has more than 2+ CPU core and 6GB+ of memory, then you can directly edit code at your server then rebuild the project from the server directly using this command,`}</p>
    <p>{`At first go to `}<inlineCode parentName="p">{`/var/www/pickbazar-laravel`}</inlineCode></p>
    <p>{`For `}<inlineCode parentName="p">{`shop rest.`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn build:shop-rest
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`for graphql `}<inlineCode parentName="p">{`yarn build:shop-gql`}</inlineCode></p>
    </blockquote>
    <p>{`And for `}<inlineCode parentName="p">{`admin rest.`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn build:admin-rest
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`for graphql `}<inlineCode parentName="p">{`yarn build:admin-gql`}</inlineCode></p>
    </blockquote>
    <p>{`After completing the build, restart the PM2 process using this command,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`pm2 restart 'all'
`}</code></pre>
    <p>{`But suppose your server doesn't have that processing power, and you try to build your scripts directly from the server. In that case, your server will be shut down during the build, and you've to restart the server.`}</p>
    <p>{`In that case, you can rebuild the scripts at your local computer and upload them to your server. If you follow our  `}<a parentName="p" {...{
        "href": "/vps-server-manual"
      }}>{`VPS Server Deployment`}</a>{` guide, then you already know the process. To build the scripts on your pc, follow this procedure,`}</p>
    <p>{`At first, download the `}<inlineCode parentName="p">{`pickbazar-laravel`}</inlineCode>{` folder from the server to your computer, and customize the code at your computer. Then use this command from the `}<inlineCode parentName="p">{`root`}</inlineCode>{` folder,`}</p>
    <p>{`To install all the packages,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn
`}</code></pre>
    <p>{`Then build the shop rest,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn build:shop-rest
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`for graphql `}<inlineCode parentName="p">{`yarn build:shop-gql`}</inlineCode></p>
    </blockquote>
    <p>{`Then build the admin rest,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn build:admin-rest
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`for graphql `}<inlineCode parentName="p">{`yarn build:admin-gql`}</inlineCode></p>
    </blockquote>
    <p>{`Then delete the shop and admin folder from the server and upload your build shop and admin folder to the server at the exact same location and use this command to restart the PM2,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`pm2 restart 'all'
`}</code></pre>
    <h2 {...{
      "id": "how-to-increase-upload-size"
    }}>{`How to increase upload size?`}</h2>
    <p>{`The API supports `}<inlineCode parentName="p">{`10MB`}</inlineCode>{` of upload limit for a single file by default. If your upload file is more than `}<inlineCode parentName="p">{`10MB`}</inlineCode>{`, then please follow this,`}</p>
    <p>{`At first, login to the server using ssh, and then,`}</p>
    <p>{`Edit,`}</p>
    <pre><code parentName="pre" {...{}}>{`/etc/php/8.1/fpm/php.ini
`}</code></pre>
    <p>{`Then update,`}</p>
    <pre><code parentName="pre" {...{}}>{`upload_max_filesize = 256M
post_max_size = 256M
max_execution_time = 300
`}</code></pre>
    <p>{`Then restart the PHP,`}</p>
    <pre><code parentName="pre" {...{}}>{`sudo service php8.1-fpm restart
`}</code></pre>
    <p>{`Then update,`}</p>
    <pre><code parentName="pre" {...{}}>{`/etc/nginx/sites-enabled/pickbazar
`}</code></pre>
    <p>{`and Add `}<inlineCode parentName="p">{`client_max_body_size 256M`}</inlineCode></p>
    <pre><code parentName="pre" {...{}}>{`client_max_body_size 256M
`}</code></pre>
    <p><img alt="BodyTime.png" src={require("./images/BodyTime.png")} /></p>
    <p>{`Then restart the server,`}</p>
    <pre><code parentName="pre" {...{}}>{`sudo nginx -t
sudo service nginx restart
`}</code></pre>
    <p>{`After that update,`}</p>
    <pre><code parentName="pre" {...{}}>{`api/packages/marvel/config/media-library.php
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`'max_file_size' => 1024 * 1024 * 256,
`}</code></pre>
    <p><img alt="UploadLimit.png" src={require("./images/UploadLimit.png")} /></p>
    <p>{`After that, run this command from the `}<inlineCode parentName="p">{`api.`}</inlineCode>{` folder,`}</p>
    <pre><code parentName="pre" {...{}}>{`php artisan optimize:clear
`}</code></pre>
    <p>{`And for `}<inlineCode parentName="p">{`admin`}</inlineCode>{`, increase `}<inlineCode parentName="p">{`timeout`}</inlineCode>{` from,`}</p>
    <pre><code parentName="pre" {...{}}>{`admin/rest/src/utils/api/http.ts
`}</code></pre>
    <p><img alt="IncreaseTime.png" src={require("./images/IncreaseTime.png")} /></p>
    <pre><code parentName="pre" {...{}}>{`timeout: 600000
`}</code></pre>
    <p>{`After that `}<a parentName="p" {...{
        "href": "/faq#how-to-rebuild-the-project"
      }}>{`Rebuild Your Project`}</a>{` and restart again.`}</p>
    <h2 {...{
      "id": "how-to-resolve-docker-invalid-reference-format-repository-name-must-be-lowercase-1"
    }}>{`How to resolve `}<inlineCode parentName="h2">{`docker: invalid reference format: repository name must be lowercase.`}</inlineCode>{`?`}</h2>
    <p>{`Please open your terminal and use this command,`}</p>
    <pre><code parentName="pre" {...{}}>{`brew services stop mysql
`}</code></pre>
    <p>{`It'll stop any MySQL instance that is installed using brew.`}</p>
    <p>{`Then use this command to check is there MySQL running or not,`}</p>
    <pre><code parentName="pre" {...{}}>{`mysql -v
`}</code></pre>
    <p>{`If no MySQL is running then, go to,`}</p>
    <pre><code parentName="pre" {...{}}>{`pickbazar-laravel -> api
`}</code></pre>
    <p>{`and use this command,`}</p>
    <pre><code parentName="pre" {...{}}>{`./vendor/bin/sail down -v
`}</code></pre>
    <p>{`After that,`}</p>
    <p>{`Open docker dashboard and delete all the existing container and images,`}</p>
    <p><img alt="DockerRemove1.png" src={require("./images/DockerRemove1.png")} />{`
`}<img alt="DockerRemove2.png" src={require("./images/DockerRemove1.png")} />{`
`}<img alt="DockerRemove3.png" src={require("./images/DockerRemove1.png")} /></p>
    <p>{`And after that remove,`}</p>
    <pre><code parentName="pre" {...{}}>{`pickbazar-laravel -> api -> .env
`}</code></pre>
    <p>{`And then go to your root `}<inlineCode parentName="p">{`pickbazar-laravel`}</inlineCode>{` folder and use this command again,`}</p>
    <pre><code parentName="pre" {...{}}>{`chmod +x install.sh
bash install.sh
`}</code></pre>
    <h2 {...{
      "id": "how-to-remove-the-existing-payment-gateway"
    }}>{`How to remove the existing payment gateway?`}</h2>
    <p>{`You can remove the Stripe Payment from the available payment array,`}</p>
    <pre><code parentName="pre" {...{}}>{`shop/src/components/checkout/payment/payment-grid.tsx
`}</code></pre>
    <h2 {...{
      "id": "why-checkout-place-order-button-is-disabled"
    }}>{`Why checkout `}<inlineCode parentName="h2">{`Place Order`}</inlineCode>{` button is disabled?`}</h2>
    <p>{`The place order button will be activated only when you fill in this information,`}</p>
    <ul>
      <li parentName="ul">{`OTP (Mobile number)`}</li>
      <li parentName="ul">{`Billing Address`}</li>
      <li parentName="ul">{`Shipping Address`}</li>
      <li parentName="ul">{`Delivery Schedule`}</li>
      <li parentName="ul">{`Payment Gateway`}</li>
    </ul>
    <h2 {...{
      "id": "how-do-i-log-in-to-the-admin-panel-as-the-main-administrator"
    }}>{`How do I log in to the admin panel as the main administrator?`}</h2>
    <p>{`When you install the API using `}<inlineCode parentName="p">{`php artisan marvel:install`}</inlineCode>{` or using `}<inlineCode parentName="p">{`bash install.sh`}</inlineCode>{`(`}<inlineCode parentName="p">{`docker`}</inlineCode>{`), you'll get a prompt to create an admin account, and you've to create admin credentials that time. And then, you can use that credentials for the main admin account.`}</p>
    <h2 {...{
      "id": "how-to-upgrade-the-existing-deployed-laravel-8-server-to-laravel-9"
    }}>{`How to upgrade the existing deployed laravel 8 server to laravel 9?`}</h2>
    <p>{`At first, remove all the existing `}<inlineCode parentName="p">{`php 7.4`}</inlineCode>{` and its extensions by using this command,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`sudo apt purge php-fpm php-mysql
sudo apt purge php-mbstring php-xml php-bcmath php-simplexml php-intl php-mbstring php7.4-gd php7.4-curl php7.4-zip composer
`}</code></pre>
    <p>{`Then remove the composer,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`sudo rm /usr/bin/composer
`}</code></pre>
    <p>{`Then delete the `}<inlineCode parentName="p">{`vendor`}</inlineCode>{` folder from the `}<inlineCode parentName="p">{`pickbazar-laravel -> api`}</inlineCode>{` folder.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd /var/www/pickbazar-laravel/api

sudo chown -R $USER:www-data storage
sudo chown -R $USER:www-data bootstrap/cache

rm vendor -rf
`}</code></pre>
    <p>{`Then install PHP 8, and its extensions,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`sudo add-apt-repository ppa:ondrej/php
sudo apt update
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`sudo apt install php8.0-fpm php8.0-mysql
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`sudo apt install php8.0-mbstring php8.0-xml php8.0-bcmath php8.0-simplexml php8.0-intl php8.0-mbstring php8.0-gd php8.0-curl php8.0-zip
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`php -r "copy('https://getcomposer.org/installer', 'composer-setup.php');"
php -r "if (hash_file('sha384', 'composer-setup.php') === 'e21205b207c3ff031906575712edab6f13eb0b361f2085f1f1237b7126d785e826a450292b6cfd1d64d92e6563bbde02') { echo 'Installer verified'; } else { echo 'Installer corrupt'; unlink('composer-setup.php'); } echo PHP_EOL;"
php composer-setup.php
php -r "unlink('composer-setup.php');"
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`sudo mv composer.phar /usr/bin/composer
`}</code></pre>
    <p>{`Then update 7.4 fpm to 8.0 fpm from,`}</p>
    <pre><code parentName="pre" {...{}}>{`/etc/nginx/sites-enabled/pickbazar
`}</code></pre>
    <p><img alt="UpdateSocket.png" src={require("./images/UpdateSocket.png")} /></p>
    <p>{`Then install composer packages,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd /var/www/pickbazar-laravel/api
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`composer install
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`php artisan optimize:clear
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`php artisan marvel:install
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`php artisan marvel:install will remove all of your existing data. Ensure you export or backup your data before using that command.`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`sudo chown -R www-data:www-data storage
sudo chown -R www-data:www-data bootstrap/cache
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      